import Benefits from "@/components/enfini/Benefits";
import Footer from "@/components/enfini/Footer";
import Header from "@/components/enfini/Header";
import HowItWorks from "@/components/enfini/HowItWorks";
import PayServices from "@/components/enfini/PayServices";
import Platforms from "@/components/enfini/Platforms";
import Services from "@/components/enfini/Services";
import Upsell from "@/components/enfini/Upsell";
import { useEffect } from "react";
import EnfiniPay from "../enfinity/our-solutions/enfinipay";

export default function Pay() {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  const benefits = [
    {
      icon: "Workflow",
      asset: "Wallet",
      title: "Fast and Reliable Payouts",
      description:
        "EnfiniPay ensures creators and partners get paid on time, every time, without unnecessary delays.",
    },
    {
      icon: "WalletCards",
      asset: "Currency",
      title: "Flexible Payment Options",
      description:
        "From local bank transfers to global payment methods, EnfiniPay gives you the flexibility to manage earnings in a way that fits your needs.",
    },
    {
      icon: "PartyPopper",
      asset: "MoneyBalance",
      title: "Perks That Add Value",
      description:
        "Enjoy exclusive perks and options that give you more control over your revenue and help you focus on building success.",
    },
  ];

  return (
    <div className="space-y-20">
      <EnfiniPay/>
    </div>
  );
}
